import { Options } from "src/app/shared/google-places/google-place.directive";
import { AbstractGooglePlaces } from "./abstract-google-places";

export class HaseGooglePlaces implements AbstractGooglePlaces {
  public getGooglePlacesOptions(): Options {
    return {
      types: ["address"],
      componentRestrictions: { country: ["hk"] },
    } as unknown as Options;
  }
}
